var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.routeParams
    ? _c(
        "p",
        { staticClass: "title" },
        [
          _vm._t("default", function () {
            return [_vm._v(" " + _vm._s(_vm.title) + " ")]
          }),
        ],
        2
      )
    : _c(
        "RouterLink",
        {
          staticClass: "title block hover:text-primary cursor-pointer",
          attrs: { to: _vm.routeParams },
        },
        [
          _vm._t("default", function () {
            return [_vm._v(" " + _vm._s(_vm.title) + " ")]
          }),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }